<template>
	<div>
		<v-dialog v-model="moveFieldDialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow>Move Field Below</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>

		        	<v-list two-line nopadding v-if="$parent.Form.activeSectionIndex != null && $parent.Form.activeFieldIndex != null">

		        		<div v-for="(fieldItem, sIndex) in $parent.Form.fieldItems" :key="sIndex">

		        			<v-subheader subheader-dense dark-grey 
		        				v-show="fn_hideSectionHeader(fieldItem.fields.length, sIndex)">
		        				{{fieldItem.section.sectionName}}
		        			</v-subheader>

		        			<div v-for="(field, fIndex) in fieldItem.fields" 
		        				:key="fIndex" 
		        				v-show="fn_isFieldItemVisible(sIndex, fIndex, field)">

		        				<v-list-tile :ripple="true" @click="moveField(sIndex, fIndex)">
				        			<v-list-tile-content>
				        			  <v-list-tile-title>{{field.displayName ? field.displayName : field.name}}</v-list-tile-title>
				        			  <v-list-tile-sub-title>{{fn_getFieldTitle(field.fieldType)}}</v-list-tile-sub-title>
				        			</v-list-tile-content>
				        		</v-list-tile>  	

				        		<v-divider></v-divider>
		        			</div>

		        		</div>
		        		
		        	</v-list>
		        	<!-- <v-radio-group v-if="$parent.Form.activeSectionIndex != null && $parent.Form.activeFieldIndex != null">

			            <div v-for="(fieldItem, sIndex) in $parent.Form.fieldItems" :key="sIndex">
			            	<v-subheader subheader-dense dark-grey>{{fieldItem.section.sectionName}}</v-subheader>
			            	<div v-for="(field, fIndex) in fieldItem.fields" 
			            		:key="fIndex" 
			            		v-show="fn_isFieldItemVisible(sIndex, fIndex, field.name)" class="radio-item-wrapper">
			            		<v-radio :label="field.name" @change="moveField(sIndex, fIndex)"></v-radio>
			            		<span>{{field.fieldType.title}} secIndex-{{sIndex}}  fieldIndex-{{fIndex}}</span>
			            	</div>
			            </div>
			        </v-radio-group> -->
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="closeMoveFieldDialog">close</v-btn>
		          	<!-- <v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">ok</v-btn> -->
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['moveField', 'closeMoveFieldDialog'],
		data(){
			return{
				moveFieldDialog:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.moveFieldDialog = true;
			},
			closeDialogWeb: function () {
				this.moveFieldDialog = false;
			},
			fn_isFieldItemVisible: function (sIndex, fIndex, field) {
				let isVisible = true;

				//Hiding current upper sibling
				if(this.$parent.Form.activeSectionIndex == sIndex && this.$parent.Form.activeFieldIndex-1 == fIndex){
					isVisible = false;
				}

				// active field name
				let fieldName = this.$parent.Form.fieldItems[this.$parent.Form.activeSectionIndex].fields[this.$parent.Form.activeFieldIndex].name;

				// active display name
				let displayName = this.$parent.Form.fieldItems[this.$parent.Form.activeSectionIndex].fields[this.$parent.Form.activeFieldIndex].displayName

				//Hiding current field
				if(field.name == fieldName && field.displayName == displayName){
					isVisible = false;
				}
				
				return isVisible;
			},
			fn_hideSectionHeader: function (fieldsLength, sIndex) {
				if(!fieldsLength){
					return false;
				}
				else{
					if(this.$parent.Form.activeSectionIndex == sIndex){
						if(fieldsLength == 1){
							return false;
						}
						else if(fieldsLength == 2 && this.$parent.Form.activeFieldIndex == 1){
							return false;
						}
					}
				}

				return true;
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/fields/dialog_move_field.vue